import get from 'lodash/get';
import * as personActions from '../../action_creators/mcp/person_action_creators';
import PersonModel from '../../../models/mcp/person_model';
import notFoundActionCreator from '../../action_creators/not_found_status_action_creator';
import log from '../../../services/logger_service';

export default function fetchPersonDetail(params, store) {
  return function firstDispatch(dispatch) {
    dispatch(personActions.personLoading({}, store));
    return PersonModel.fetch(params, store)
      .then(function handlePersonDetailData(PersonData) {
        dispatch(personActions.personLoaded(PersonData.data, store));
      })
      .catch(function handleUserError(err) {
        const status = get(err, 'response.status.code') || 500;

        if (status === 404 || status === 401) {
          dispatch(notFoundActionCreator(404, 'NOT_FOUND_STATUS', store));
        }

        if (status === 500) {
          dispatch(notFoundActionCreator(500, 'ERROR_STATUS', store));
          log.error(err, `Error in person actions, message: ${err.message}`);
        }

        return dispatch(personActions.personLoadError(err, store));
      });
  };
}
